import { restClient } from '@/Core'

import { adminPath } from './diskAdminApi'

/**
 * Архів колишнього «Мого диска» — знову особистий диск власника (після
 * повторної активації): `POST /services/disk/admin/storages/{uuid}/restore-to-owner`.
 */
export const RestoreDiskStorageToOwnerTask = async (uuid: string): Promise<void> => {
    await restClient.post(adminPath('storages', uuid, 'restore-to-owner'), { json: {} })
}
